module.exports = __webpack_public_path__ + "static/p-logo--w2commerceValue5-9f7608277757d5aab225cb047e8573a4.png";